// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---node-modules-gatsby-plugin-offline-app-shell-js": () => import("./../node_modules/gatsby-plugin-offline/app-shell.js" /* webpackChunkName: "component---node-modules-gatsby-plugin-offline-app-shell-js" */),
  "component---src-pages-hackathon-js": () => import("./../src/pages/hackathon.js" /* webpackChunkName: "component---src-pages-hackathon-js" */),
  "component---src-pages-index-js": () => import("./../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-youtube-js": () => import("./../src/pages/youtube.js" /* webpackChunkName: "component---src-pages-youtube-js" */)
}

